import { isTablet } from './isTablet.util'

export const addKeyboardSpacer = (id: string): void => {
  if (!isTablet()) {
    const element = document.getElementById(id)
    const newSpacer = document.createElement('div')
    newSpacer.id = 'spacer'
    newSpacer.style.height = '40vh'
    newSpacer.style.width = '100%'

    if (element) {
      const { parentNode, nextSibling } = element
      parentNode?.insertBefore(newSpacer, nextSibling)
    }

    newSpacer.scrollIntoView(false)
  }
}

export const removeKeyboardSpacer = (): void => {
  if (!isTablet()) {
    const spacer = document.getElementById('spacer')
    if (spacer) {
      spacer.scrollIntoView(false)
      const { parentNode } = spacer
      parentNode?.removeChild(spacer)
    }
  }
}
